module.exports = __webpack_public_path__ + "static/img/panel1.b9adaa26.png";